<template>
  <div class="page-list">
    <div v-if="$slots.topBox" class="top-part">
      <slot name="topBox" />
    </div>
    <div class="main-box">
      <div v-if="$slots.leftBox" class="left-part">
        <slot name="leftBox" />
      </div>
      <div class="right-part">
        <div v-if="$slots.searchBox" class="search-box">
          <slot name="searchBox" />
        </div>
        <div v-if="$slots.btnBox" class="btn-box" :class="{'has-padding': $slots.searchBox}">
          <slot name="btnBox" />
        </div>
        <div class="table-box">
          <slot name="tableBox" />
        </div>
        <div v-if="$slots.footerBox" class="footer-box">
          <slot name="footerBox" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GjwListPageLayout',
  inheritAttrs: false,
}
</script>

<style lang="less" scoped>
  .page-list{
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }
  .top-part{
    flex: 0 0 auto;
  }
  .main-box{
    display: flex;
    flex-direction: row;
    flex: 1;
    border-top: 1px solid #D2D9E3;
  }
  .left-part{
    overflow: auto;
    width: 220px;
    min-height: 100%;
    border-right: 1px solid #D2D9E3;
    /deep/ .el-tree{
      position: static;
    }
  }
  .right-part{
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding: 10px 16px;
  }
  .search-box{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 1px solid #D2D9E3;
  }
  .btn-box{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    /deep/ .el-button-group{
      line-height: 44px;
    }
    &.has-padding{
      padding-top: 6px;
    }
  }
  .table-box {
    width: 100%;
    flex: 1;
    overflow: auto;
    /deep/ .el-button+.el-button{
      margin-left: 6px;
    }
    /deep/ .el-button+.el-dropdown {
      margin-left: 6px;
    }
  }
  .footer-box {
    width: 100%;
    text-align: right;
    position: relative;
    margin-top: 20px;
  }
</style>
